import {
    Box,
    Container,
    Divider,
    Flex,
    IconButton,
    Image,
    Stack,
    Text,
    Link,
} from '@chakra-ui/react';
import { Link as ReactLink } from 'react-router-dom';
import { FaFacebookF } from 'react-icons/fa';

const Footer = () => {
    return (
        <Box
            as="footer"
            bg="white"
            borderTop="1px solid"
            borderColor="gray.200"
            pt={{ base: 10, md: 14 }}
            pb={6}
            fontFamily="Poppins, sans-serif"
        >
            <Container maxW="7xl">

                <Flex
                    direction={{ base: 'column', lg: 'row' }}
                    justify="space-between"
                    align={{ base: 'center', lg: 'flex-start' }}
                    gap={{ base: 10, lg: 14 }}
                >

                 
                    <Stack
                        spacing={4}
                        maxW="300px"
                        align={{ base: 'center', lg: 'flex-start' }}
                        textAlign={{ base: 'center', lg: 'left' }}
                    >
                        <Flex
                            as={ReactLink}
                            to="/"
                            align="center"
                            gap={3}
                        >
                            <Image
                                src="/images/laskoditesztalogo.png"
                                alt="Laskodi Tészta"
                                width="72px"
                                height="72px"
                                objectFit="contain"
                            />

                            <Box>
                                <Text
                                    fontSize="xl"
                                    fontWeight="700"
                                    lineHeight="1"
                                    color="gray.800"
                                    letterSpacing="0.5px"
                                >
                                    LASKODI
                                </Text>

                                <Text
                                    fontSize="sm"
                                    fontWeight="600"
                                    letterSpacing="1px"
                                    color="red.600"
                                    mt={0}
									textAlign='center'
                                >
                                    TÉSZTA
                                </Text>
                            </Box>
                        </Flex>

                        <Text
                            fontSize="sm"
                            color="gray.600"
                            lineHeight="1.8"
                        >
                            Hagyományos, házias jellegű száraztészták
                            hazai alapanyagokból, több mint 25 éve.
                        </Text>
                    </Stack>
                    <Stack
                        spacing={3}
                        align={{ base: 'center', lg: 'flex-start' }}
                    >
                        <Text
                            fontSize="sm"
                            fontWeight="600"
                            color="gray.800"
                            textTransform="uppercase"
                            letterSpacing="1px"
                            mb={1}
                        >
                            Menü
                        </Text>

                        <FooterLink to="/rolunk">
                            Rólunk
                        </FooterLink>

                        <FooterLink to="/tesztaink">
                            Tésztáink
                        </FooterLink>

                        <FooterLink to="/palyazat">
                            Pályázatok
                        </FooterLink>

                        <FooterLink to="/kapcsolat">
                            Kapcsolat
                        </FooterLink>
                    </Stack>
                    <Stack
                        spacing={3}
                        align="center"
                        textAlign="center"
                        maxW="180px"
                    >
                        <Text
                            fontSize="sm"
                            fontWeight="600"
                            color="gray.800"
                        >
                            Megbízható vállalkozás
                        </Text>

                        <Image
                            src="/images/emblema.png"
                            alt="BCP Highly Trustworthy Company 2026"
                            width={{ base: "105px", md: "115px" }}
                            objectFit="contain"
                            transition="0.25s ease"
                            _hover={{
                                transform: 'scale(1.04)',
                            }}
                        />

                        <Text
                            fontSize="xs"
                            color="gray.500"
                            lineHeight="1.5"
                        >
                            BCP Rating 2026
                        </Text>
                    </Stack>
                    <Stack
                        spacing={3}
                        align={{ base: 'center', lg: 'flex-start' }}
                        textAlign={{ base: 'center', lg: 'left' }}
                        maxW="300px"
                    >
                        <Text
                            fontSize="sm"
                            fontWeight="600"
                            color="gray.800"
                            textTransform="uppercase"
                            letterSpacing="1px"
                            mb={1}
                        >
                            Elérhetőség
                        </Text>

                        <Text
                            fontSize="sm"
                            color="gray.600"
                            lineHeight="1.7"
                        >
                            4543 Laskod,
                            <br />
                            Szabadság út 31.
                        </Text>

                        <Stack spacing={1}>
                            <Link
                                href="tel:+36302181850"
                                fontSize="sm"
                                color="gray.600"
                                _hover={{ color: 'red.500' }}
                            >
                                +36 30 218 1850
                            </Link>

                            <Link
                                href="tel:+36305090425"
                                fontSize="sm"
                                color="gray.600"
                                _hover={{ color: 'red.500' }}
                            >
                                +36 30 509 0425
                            </Link>
                        </Stack>

                        <Stack spacing={1}>
                            <Link
                                href="mailto:laskoditeszta@hu.inter.net"
                                fontSize="sm"
                                color="gray.600"
                                _hover={{ color: 'red.500' }}
                            >
                                laskoditeszta@hu.inter.net
                            </Link>

                            <Link
                                href="mailto:aranytoj@hu.inter.net"
                                fontSize="sm"
                                color="gray.600"
                                _hover={{ color: 'red.500' }}
                            >
                                aranytoj@hu.inter.net
                            </Link>
                        </Stack>
                    </Stack>
                </Flex>


                <Divider my={{ base: 8, md: 10 }} />
                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    justify="space-between"
                    align="center"
                    gap={4}
                >
                    <Text
                        fontSize="xs"
                        color="gray.500"
                        textAlign="center"
                    >
                        © {new Date().getFullYear()} Laskodi Tészta.
                        Minden jog fenntartva.
                    </Text>

                    <Flex gap={5}>
                        <Link
                            as={ReactLink}
                            to="/aszf"
                            fontSize="xs"
                            color="gray.500"
                            _hover={{ color: 'red.500' }}
                        >
                            ÁSZF
                        </Link>

                        <Link
                            as={ReactLink}
                            to="/adatkezeles"
                            fontSize="xs"
                            color="gray.500"
                            _hover={{ color: 'red.500' }}
                        >
                            Adatkezelés
                        </Link>

                        <IconButton
                            as="a"
                            href="#"
                            aria-label="Facebook"
                            icon={<FaFacebookF />}
                            variant="ghost"
                            size="sm"
                            borderRadius="full"
                            color="gray.600"
                            _hover={{
                                bg: 'red.50',
                                color: 'red.500',
                            }}
                        />
                    </Flex>
                </Flex>

            </Container>
        </Box>
    );
};


const FooterLink = ({ children, to }) => (
    <Link
        as={ReactLink}
        to={to}
        fontSize="sm"
        fontWeight="400"
        color="gray.600"
        transition="0.2s ease"
        _hover={{
            color: 'red.500',
            textDecoration: 'none',
            transform: 'translateX(3px)',
        }}
    >
        {children}
    </Link>
);

export default Footer;